module.exports = __webpack_public_path__ + "img/rod_08.787a5373.svg";